"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _cccisdLaravelReport = require("cccisd-laravel-report");
var _menu = _interopRequireDefault(require("cccisd-icons/menu7"));
var _spinner = _interopRequireDefault(require("cccisd-icons/spinner8"));
var _round2 = _interopRequireDefault(require("lodash/round"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var SummaryTable = function SummaryTable(props) {
  var colors = props.colors;
  var _renderSessionCols = function _renderSessionCols(fill, fillVal) {
    // fill = array of cell indexes to fill
    // fillVal = value to fill in these cells
    var sessionCols = [];
    for (var i = 1; i <= props.totalSessions; i++) {
      var cellVal = void 0;
      if (fill) {
        if (fill.includes(i)) {
          cellVal = fillVal;
        }
      } else {
        cellVal = i;
      }
      sessionCols.push( /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].tableHeadingAlt,
        key: i
      }, cellVal));
    }
    return sessionCols;
  };
  var _renderTableBody = function _renderTableBody(data) {
    // console.log({ data });
    if (data.length < 1) {
      return /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        colSpan: props.totalSessions * 2 + 4
      }, "No data has been entered for the selected groups."));
    }
    return data.map(function (facilitator) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: facilitator.groupName
      }, /*#__PURE__*/_react["default"].createElement("tr", {
        key: facilitator.id
      }, /*#__PURE__*/_react["default"].createElement("td", null, facilitator.name), facilitator.scores.map(function (score, index) {
        var scoreValue = score;
        if (_typeof(score) !== 'object') {
          scoreValue = (0, _round2["default"])(Number(score), 1);
        }
        return /*#__PURE__*/_react["default"].createElement("td", {
          key: index
        }, scoreValue);
      })));
    });
  };
  var renderTable = function renderTable(tableProps) {
    if (tableProps.data.length > 0 && !tableProps.loading) {
      // console.log(tableProps.data);
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.BrowserOnly, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn-group",
        style: {
          marginBottom: '0.7em'
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-sm btn-default dropdown-toggle ".concat(_style["default"].multipurposeButton, " ").concat(tableProps.loading ? _style["default"].rotating : ''),
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false"
      }, tableProps.loading ? /*#__PURE__*/_react["default"].createElement(_spinner["default"], null) : /*#__PURE__*/_react["default"].createElement(_menu["default"], null)), /*#__PURE__*/_react["default"].createElement("ul", {
        className: "dropdown-menu"
      }, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "",
        onClick: tableProps.loadData
      }, "Reload data")), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "",
        onClick: tableProps.downloadCsv
      }, "Download CSV"))))), /*#__PURE__*/_react["default"].createElement("table", {
        className: _style["default"].table
      }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", {
        className: _style["default"].tableHeading,
        rowSpan: "2",
        style: colors ? {
          backgroundColor: colors.primary
        } : {}
      }, "Facilitator Name"), /*#__PURE__*/_react["default"].createElement("th", {
        colSpan: props.totalSessions,
        className: _style["default"].tableHeading,
        style: colors ? {
          backgroundColor: colors.primary
        } : {}
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Session Number"))), /*#__PURE__*/_react["default"].createElement("tr", null, _renderSessionCols())), /*#__PURE__*/_react["default"].createElement("tbody", null, _renderTableBody(props.convertDataStructure(tableProps.data)))));
    }
    return null;
  };
  var columns = [{
    name: 'group.label',
    label: 'Group Name',
    sort: true
  }];
  return /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
    rowKey: "group.groupId",
    query: props.query,
    graphqlVariables: {
      groupIds: props.filters.groupIds,
      startDate: props.filters.startDate,
      endDate: props.filters.endDate
    },
    columns: columns,
    render: function render(tableProps) {
      return renderTable(tableProps);
    }
  });
};
SummaryTable.propTypes = {
  settings: _propTypes["default"].object,
  isPreview: _propTypes["default"].bool,
  filters: _propTypes["default"].object,
  query: _propTypes["default"].object,
  colors: _propTypes["default"].object,
  totalSessions: _propTypes["default"].number,
  convertDataStructure: _propTypes["default"].func,
  targetScore: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
};
SummaryTable.defaultProps = {
  filters: {},
  totalSessions: 7,
  convertDataStructure: function convertDataStructure(data) {
    var convertedData = [];
    if (data.length > 0) {
      var apl = data[0]['childRoles.metricspawn.assignmentProgressList'];
      convertedData = [{
        id: 0,
        name: 'Facilitator 1',
        scores: apl.map(function (i) {
          return i.devTags.Facilitator1EvaluationScore;
        })
      }, {
        id: 1,
        name: 'Facilitator 2',
        scores: apl.map(function (i) {
          return i.devTags.Facilitator2EvaluationScore;
        })
      }, {
        id: 2,
        name: 'Facilitator 3',
        scores: apl.map(function (i) {
          return i.devTags.Facilitator3EvaluationScore;
        })
      }];
    } else {
      convertedData = [{
        id: 0,
        name: 'Facilitator 1',
        scores: ['1.123456789', '3.43567', null, null, null, null, null]
      }, {
        id: 1,
        name: 'Facilitator 2',
        scores: ['5', '4', '4', '5', '2', null, null]
      }, {
        id: 2,
        name: 'Facilitator 3',
        scores: ['3', '3', '3', '2', '2', null, null]
      }];
    }
    // console.log({ convertedData });
    return convertedData;
  }
};
var _default = exports["default"] = SummaryTable;